export default "__VITE_ASSET__CLC0o6ky__"